"use strict";

var Isoxys = require('./dist/isoxys');

var Metamask = require('./dist/metamask');

var MEW = require('./dist/mew');

var Trust = require('./dist/trust');

var Ledger = require('./dist/ledger');

var Trezor = require('./dist/trezor');

var _require = require('./dist/provider'),
    LiteWallet = _require.LiteWallet,
    NonWallet = _require.NonWallet;

module.exports = {
  Isoxys: Isoxys,
  Metamask: Metamask,
  MEW: MEW,
  Trust: Trust,
  Ledger: Ledger,
  Trezor: Trezor,
  LiteWallet: LiteWallet,
  NonWallet: NonWallet
};
